import { PropsWithChildren } from "react";

import { usePartnerLoginRedirect } from "@/apps/partner/hooks/usePartnerLoginRedirect";
import { WelcomeLoadingSpinner } from "@/components/Welcome/WelcomeLoadingSpinner.tsx";

export const PartnerLoginRedirect = ({ children }: PropsWithChildren) => {
  const isRedirecting = usePartnerLoginRedirect();
  if (isRedirecting) {
    return <WelcomeLoadingSpinner />;
  }

  return children;
};
